'use client';
import LeadCaptureForm from '@/components/form/LeadCaptureForm/LeadCaptureForm';

type Option = {
  option: string;
};

type LeadCapturerProps = {
  /** Header text to display at the top of the form */
  headerText: string;

  /** Optional subheader text to display below the header */
  subHeaderText?: string;

  /** Text to display on the submit button */
  ctaButtonText: string;

  /** Optional dropdown field configuration */
  dropDownField?: {
    label: string;
    options: Option[];
  };

  /** Optional CSS class name for styling */
  className?: string;
};

function LeadCapturer(props: LeadCapturerProps) {
  const { headerText, subHeaderText, ctaButtonText, dropDownField, className } =
    props;

  return (
    <LeadCaptureForm
      className={className}
      headerText={headerText}
      subHeaderText={subHeaderText}
      ctaButtonText={ctaButtonText}
      dropDownField={dropDownField}
      initialValues={{
        phoneNumber: '',
        firstName: '',
        lastName: '',
        email: '',
        favoriteCategory: dropDownField?.options[0]?.option || '',
        optInText: false
      }}
    />
  );
}

export default LeadCapturer;
